module.exports = __webpack_public_path__ + "assets/img/tx112_3.914afc13.jpg";